import { checkAuthentication } from './middleware';
export const monitoringRoutes = [
    {
        path: '/monitoring/:id/status=:tab?',
        name: 'MonitoringList',
        component:  () => import(/* webpackChunkName: "author-route" */ '../views/monitoring/MonitoringList.vue'),
        props: true,
        beforeEnter: checkAuthentication
    },
    {
        path: '/job/:tab?/:id',
        name: 'JobDetails',
        component: () => import(/* webpackChunkName: "author-route" */ '../views/monitoring/JobDetails.vue'),
        props: true,
        beforeEnter: checkAuthentication
    },
]